import { map } from "ramda";
import { AccountPresenter } from "../presenter/types";
import { HighlightedCell } from "./types";

export const buildHighlightedCells = (
  account: AccountPresenter,
  period: number
): HighlightedCell[] => {
  const accountsToHighlight =
    account.userEditedByPeriod[period] && account.type === "VALUE"
      ? [account]
      : getTargetAccounts(account.children, [], period);

  return map(
    acct =>
      ({
        period,
        spreadSheetType: account.spreadSheetType,
        accountId: acct.id
      } as HighlightedCell),
    accountsToHighlight
  );
};

const getTargetAccounts = (
  accounts: AccountPresenter[],
  accumArray: AccountPresenter[],
  period: number
) => {
  accounts.forEach(account => {
    if (account.periodValues[period]) {
      accumArray.push(account);
    }
    if (account.children.length > 0) {
      getTargetAccounts(account.children, accumArray, period);
    }
  });
  return accumArray;
};



// WEBPACK FOOTER //
// ./src/spread/model/highlightedCells/helpers.ts